module.exports = __webpack_public_path__ + "img/colorful-separator.de27974a.svg";